import {isBefore} from 'date-fns';
import type {DateRange} from 'react-day-picker';

type ResolveRangeSelectionParams = {
  previous: DateRange | undefined;
  range: DateRange | undefined;
  pickedDate: Date | undefined;
};

type ResolveRangeSelectionResult = {
  next: DateRange | undefined;
  shouldClose: boolean;
};

export function resolveRangeSelection({
  previous,
  range,
  pickedDate,
}: ResolveRangeSelectionParams): ResolveRangeSelectionResult {
  const startingNewRange =
    !previous?.from ||
    (previous.from && previous.to) ||
    (range?.to && pickedDate && isBefore(pickedDate, range.to));

  if (startingNewRange) {
    return {next: {from: pickedDate, to: undefined}, shouldClose: false};
  }

  const next = range;
  const shouldClose = Boolean(
    (next?.from && next?.to) ||
    (pickedDate && range?.from && isBefore(range.from, pickedDate)),
  );
  return {next, shouldClose};
}
